/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { DateValue, DateTimeValue } from 'app/shared/lib/date-time';

@autoinject
export class TestEssTime extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected referenceDate: string | null = null;
    protected dateTime: string | null = null;
    protected readonly: boolean = false;
    protected placeholder: string | null = null;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    //constructor(...rest: any[]) { super(...rest); }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    protected toggleReadonly(): void {
        this.readonly = !this.readonly;
    }

    protected changeDateTime(value: string | null): void {
        this.dateTime = value;
    }

    protected changeReferenceDate(value: string | null): void {
        this.referenceDate = value;
    }

    protected changePlaceholder(value: string | null): void {
        this.placeholder = value;
    }

    protected combineDateTime(date: string, time: string): string | null {
        return new DateTimeValue(time).changeDate(new DateValue(date), this.env.displayTimeZone).toJSON();
    }

    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
